import { Button, intl } from 'ehs-react';
import React from 'react';
import { usePortletStore } from '../App';

function AuthenticationWizardOnboardingCompletePage({
  onNextPage
}: Readonly<{
  onNextPage: () => void;
}>): JSX.Element {
  const [createUserAccountAllowed] = usePortletStore(state => [
    state.configuration.createUserAccountAllowed
  ]);
  return (
    <form>
      <p className="font-16 s-font">
        {createUserAccountAllowed
          ? intl(
              'patientSelfOnboardingPortlet.onboardingCompletePage.createUserAccountComplete.descriptionText'
            )
          : intl(
              'patientSelfOnboardingPortlet.onboardingCompletePage.patientSelfOnboardingComplete.descriptionText'
            )}
      </p>
      <p className="font-16 s-font">
        {intl(
          'patientSelfOnboardingPortlet.onboardingCompletePage.proceedText'
        )}
      </p>
      <div className="content-button-bar">
        <Button
          scale={'medium'}
          autoFocus={true}
          text={intl(
            'patientSelfOnboardingPortlet.onboardingCompletePage.buttonProceed'
          )}
          variant="primary"
          onClick={() => onNextPage()}
        />
      </div>
    </form>
  );
}

export default AuthenticationWizardOnboardingCompletePage;
